import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {Link} from "@reach/router";

class PhotoList extends Component{
  click = (e)=>{
    const url = this.props.data.url.startsWith('../') ? this.props.data.url.substring(3, this.props.data.url.length) : this.props.data.url;
    document.location.href = url;
    e.preventDefault();
    return false;
  }

  render(){
    return (
      <>
      <li className="photo-item">
        <div className="pointer photo-item-inner" onClick={this.click} >
        <img src={this.props.data.image} />
        </div>
      </li>
      </>
    );
  }
}

export default PhotoList;
